import styled from 'styled-components';
import { Row, Col, Input, Select } from 'antd';

export const CustomerInfoFormWrapper = styled.div`
  background-color: #fff;
  padding: 10px;
  border-radius: 8px;
  // box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

export const FormRow = styled(Row)`
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const FormCol = styled(Col)`
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    margin-bottom: 16px;
    width: 100%; // Ensure full width on smaller screens
  }
`;

export const StyledInput = styled(Input)`
  && {
    border-color: ${({ theme }) => theme.inputBorder || '#DFEAF2'} !important;

    &:focus,
    &:hover {
      border-color: ${({ theme }) => theme.primary || '#006CCF'} !important;
      box-shadow: 0 0 0 2px rgba(0, 108, 207, 0.2) !important;
    }
  }
`;

export const AvatarWrapper = styled.div`
  position: relative;
  width: 150px;
  height: 100px;

  @media (max-width: 768px) {
    width: 120px;
    height: 120px;
    margin-bottom: 16px;
  }

  .ant-avatar {
    width: 100%;
    height: auto;
  }
`;

export const StyledSelect = styled(Select)`
  && .ant-select-selection-placeholder {
    font-weight: normal;
  }
`;
